import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { ThemeStatus } from "@/lib/api/types";

const STATUS_CLASS: Record<ThemeStatus, string> = {
  DRAFT:
    "bg-[color:var(--warning-100)] text-[color:var(--warning-700)]",
  PUBLISHED:
    "bg-[color:var(--success-100)] text-[color:var(--success-600)]",
  ARCHIVED:
    "bg-[color:var(--background-muted)] text-[color:var(--text-muted)]",
};

const STATUS_LABEL_KEY: Record<ThemeStatus, string> = {
  DRAFT: keys.themes.draft,
  PUBLISHED: keys.themes.published,
  ARCHIVED: keys.themes.archived,
};

export function ThemeStatusBadge({ status }: { status: ThemeStatus }) {
  const t = useTranslations();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${STATUS_CLASS[status]}`}
    >
      {t(STATUS_LABEL_KEY[status])}
    </span>
  );
}
